const initialState = {
  suppliers: [],
};

function SupplierReducer(state = initialState, action) {
  if (action.type === "SUPPLIERS_LIST") {
    var supplierDetails = {
      ...state,
      suppliers: action.payload,
    };
    return supplierDetails;
  }

  return state;
}

export default SupplierReducer;
